import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocialTagsService {

  constructor(
    private titleService: Title,
    private metaService: Meta,
  ) { }

  setTitle(title?: string): void {
    // Update title tag
    let updatedTitle = 'identibase.co.uk';
    if (title) {
      updatedTitle = `${title} | ${updatedTitle}`;
    }
    this.titleService.setTitle(updatedTitle);

    // Update socials title meta tags
    this.metaService.updateTag({
      property: 'og:title',
      content: updatedTitle
    });
    this.metaService.updateTag({
      name: 'twitter:title',
      content: updatedTitle
    });
  }

  setDescription(description?: string): void {
    // Update main description meta tag
    const updatedDescription = description || 'identibase is a national database containing the details of microchipped pets and their owners.';
    this.metaService.updateTag({
      name: 'description',
      content: updatedDescription
    });

    // Update socials description meta tags
    this.metaService.updateTag({
      property: 'og:description',
      content: updatedDescription
    });
    this.metaService.updateTag({
      name: 'twitter:description',
      content: updatedDescription
    });
  }

  setImage(image?: string): void {
    let updatedImage: string;
    if (/^(http:\/\/|https:\/\/)/.test(image)) {
      updatedImage = image;
    } else {
      updatedImage = `${environment.canonicalUrl}/assets/images/socials/${image || 'default.png'}`;
    }
    // Update socials image meta tags
    this.metaService.updateTag({
      property: 'og:image',
      content: updatedImage
    });
    this.metaService.updateTag({
      name: 'twitter:image',
      content: updatedImage
    });
  }
}
